import { ImageProps } from 'next/image';

import { Article } from '@natu/ui/Article';
import { getSlugWithDash } from '@natu/utils/getSlugWithDash';
import { isArrayWithLength } from '@natu/utils/isArrayWithLength';

import {
  getAssetFromStoryblok,
  getDescriptiveText,
  SbComponentType,
  sbEditable,
} from '../../../../../../utils';
import { ArticleNodes } from '../../../../../../utils/src/types/Blog/ArticleNode.types';
import { getDateAndReadTime } from '../../../../utils/getDateAndReadTime';

interface ArticlesGridProps {
  id: string;
  articles?: ArticleNodes['stories'];
}

const ArticlesGrid = ({ id, articles }: ArticlesGridProps) => {
  if (!isArrayWithLength(articles)) return null;

  return (
    <ul className="grid grid-cols-1 gap-8 lg:grid-cols-3 lg:gap-y-10">
      {articles.map((article, _i) => {
        if (!article) return null;

        const { _uid, title, description, timeToRead, previewImage } = article.content || {};
        const restProps = sbEditable(article.content as SbComponentType);
        const image = getAssetFromStoryblok(previewImage) as ImageProps;

        const { descriptiveText } = getDescriptiveText({
          title: 'Read more',
          slug: article.full_slug,
        });

        return (
          <li key={`${_uid}${id}${_i}`} {...restProps}>
            <Article
              label={getDateAndReadTime(article.first_published_at, timeToRead)}
              title={title || ''}
              description={description}
              image={image}
              url={getSlugWithDash(article.full_slug)}
              descriptiveText={descriptiveText}
            />
          </li>
        );
      })}
    </ul>
  );
};

export default ArticlesGrid;
